export const hasMixedVideoAndNonVideoProducts = (creativeProducts = [], videoProducts = []) => {
  const videoProductNames = new Set(videoProducts);
  const hasVideo = creativeProducts.some(cp => videoProductNames.has(cp.name));
  const hasNonVideo = creativeProducts.some(cp => !videoProductNames.has(cp.name));
  return hasVideo && hasNonVideo;
};

export const mixedVideoAndNonVideoMessage =
  'Cannot combine Preroll and non-Preroll on the same placement';
